(() => {
  'use strict';
  const page = document.querySelector('[data-wishlist-page]');
  if (!page || !window.taWishlist) return;
  const strings = JSON.parse(document.getElementById('ta-wishlist-config').textContent);
  const grid = page.querySelector('[data-wishlist-items]');
  const status = page.querySelector('[data-wishlist-message]');
  const more = page.querySelector('[data-wishlist-more]');
  const root = page.dataset.root.replace(/\/?$/, '/');
  const money = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: page.dataset.currency });
  let shown = 12, generation = 0;
  const cache = new Map();
  const element = (tag, text, className) => {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (className) el.className = className;
    return el;
  };
  async function product(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { signal: AbortSignal.timeout(10000) });
    if (response.status === 404) { cache.set(handle, null); return null; }
    if (!response.ok) throw new Error('load');
    const value = await response.json();
    cache.set(handle, value);
    return value;
  }
  async function render() {
    const run = ++generation;
    const handles = window.taWishlist.read();
    grid.replaceChildren();
    status.textContent = handles.length ? strings.loading : strings.empty;
    more.hidden = handles.length <= shown;
    const queue = handles.slice(0, shown).map(handle => {
      const card = element('article', '', 'ta-wishlist-item');
      const content = element('div');
      card.append(content);
      const remove = element('button', strings.remove, 'ta-wishlist-remove');
      remove.type = 'button';
      remove.addEventListener('click', () => {
        if (window.taWishlist.remove(handle)) requestAnimationFrame(() => (grid.querySelector('button') || more).focus());
      });
      card.append(remove); grid.append(card);
      return { handle, content, remove };
    });
    let failed = false;
    async function worker() {
      while (queue.length && run === generation) {
        const {handle, content, remove} = queue.shift();
        try {
          const p = await product(handle);
          if (run !== generation) return;
          if (!p) { content.textContent = strings.unavailable; continue; }
          const link = element('a');
          link.href = root + 'products/' + encodeURIComponent(handle);
          if (p.featured_image) {
            const url = new URL(p.featured_image, location.origin);
            if (url.protocol === 'https:') {
              url.searchParams.set('width', '480');
              const img = document.createElement('img');
              img.src = url.href; img.alt = p.title; img.loading = 'lazy'; img.width = 480; img.height = 480;
              link.append(img);
            }
          }
          link.append(element('h2', p.title, 'h5'));
          content.append(link, element('p', (p.price_varies ? strings.from + ' ' : '') + money.format(p.price / 100)));
          if (!p.available) content.append(element('p', strings.sold_out, 'text-subdued'));
          remove.setAttribute('aria-label', strings.remove + ': ' + p.title);
        } catch {
          failed = true;
          content.textContent = strings.load_error;
        }
      }
    }
    await Promise.all([worker(), worker(), worker()]);
    if (run === generation) status.textContent = !handles.length ? strings.empty : failed ? strings.load_error : '';
  }
  more.addEventListener('click', () => { shown += 12; render(); });
  document.addEventListener('ta:wishlist-change', render);
  render();
})();
